// extracted by mini-css-extract-plugin
export default {"contact":"styles_contact__gSwB9","contactTitle":"styles_contactTitle__b9wm8","contactSubtitle":"styles_contactSubtitle__+Mcb0"};